__turbopack_context__.v({
  "innerContainer": "table-module__uogUqG__innerContainer",
  "item": "table-module__uogUqG__item",
  "itemHighlight": "table-module__uogUqG__itemHighlight",
  "list": "table-module__uogUqG__list",
  "outerContainer": "table-module__uogUqG__outerContainer",
  "scroller": "table-module__uogUqG__scroller",
});
